(function() {
  const anchorWrapper = document.querySelector('.article-template__anchors-wrapper');
  const anchorsContainer = anchorWrapper?.querySelector('.article-template__anchors-container');

  if (!anchorWrapper || !anchorsContainer) return;

  anchorsContainer.style.height = `${anchorsContainer.firstElementChild.offsetHeight}px`;

  anchorWrapper.addEventListener('click', (e) => {
    if (e.target.classList.contains('article-template__anchor-tab') || e.target.closest('.article-template__anchor-tab')) {
      const anchorsContainer = e.currentTarget.querySelector('.article-template__anchors-container');
      e.currentTarget.classList.toggle('open');

      if (!anchorsContainer) return;

      if (e.currentTarget.classList.contains('open')) {
        anchorsContainer.style.height = `${anchorsContainer.firstElementChild.offsetHeight}px`;
      } else {
        anchorsContainer.style.height = '0';
      }
    }

    if (e.target.classList.contains('article-template__anchor') || e.target.closest('.article-template__anchor')) {
      const textContent = e.target.textContent;
      const articleContentEl = document.querySelector('.article-template__content .rte');
      const articleHeadings = articleContentEl.querySelectorAll('h1, h2, h3, h4, h5, h6');

      if (!articleContentEl || articleHeadings.length === 0) return;

      const element = Array.from(articleHeadings).find(el => el.textContent.includes(textContent));
      const header = document.querySelector('.header-wrapper');
      let y = window.scrollY;

      if (element) {
        y = y + element.getBoundingClientRect().top - 12;
      }

      if (header) {
        y -= header.offsetHeight;
      }

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      })
    }
  });
})();
